<svelte:head>
 
	{#if $activity && $activity.settings}
		<title>{$activity.titles[0]}</title>
	<meta name='description' content='{$activity.settings.desc}'>

	<meta name="twitter:site" content="@mspanish">
	<meta name="twitter:title" content="{$activity.titles[0]}">
	<meta name="twitter:description" content="{$activity.settings.desc}">
	<meta name="twitter:creator" content="@mspanish">
	<meta name="twitter:image" content="{$activity.settings.img.replace('../', 'https://talker.netlify.com/')}">
	
	<meta property="og:title" content="{$activity.titles[0]}" />
	<meta property="og:type" content="article" />
	<meta property="og:url" content="https://talker.netlify.com/{$activity.settings.name}.html" />
	<meta property="og:image" content="{$activity.settings.img.replace('../', 'https://talker.netlify.com/')}" />
	<meta property="og:description" content="{$activity.settings.desc}" />
	
	{/if}
</svelte:head>


<Sharing bind:activity=$activity/>
 
<div class="content is-medium">
  <h1>AAC Activities, Ideas, Lesson Plans</h1>
</div> 
    
  <p>We've done a lot of work with our wonderful SLP this year, and I thought it might be nice to share some of our AAC pages, activities, and strategies for helping initiate communication. These are written by Stacey Reiman, and are from a parent perspective. </p>
  
  {#if $activities}
<table class="table">
  <thead>
    <tr>
		<th></th>
      <th>name</th>
      <th>description</th>
	  <th>date</th>
    </tr>
  </thead>
  <tfoot>
    <tr>
	
    </tr>
  </tfoot>
  <tbody>
     
	{#each $activities as activity, x}
    <tr>
	  <td><a href="../{activity.settings.name}.html"><img class="thumb" src="{activity.settings.img}"></a></td>
      <td><a href="../{activity.settings.name}.html">{activity.titles[0]}</a></td>
      <td>{activity.settings.desc}</td>
	  <td data-sort="{activity.dateRaw}">{activity.date}</td>
	
	</tr>
	{/each}
	
	</tbody>
</table>

{/if}


<style>
	.content {
	padding-top:20px;
	}
    ul {
      padding: 0;
    }
  
    ul li {
      text-decoration: underline;
      text-align: center;
      list-style: none;
      color: FireBrick;
    }

	td {
	padding-right: 30px;
	padding-left: 10px
	} 
	tr:hover {
	 opacity:.9;
	 background-color:lightyellow;
	 cursor:pointer;
	}
  </style>
   
<script>
  import roadtrip from 'roadtrip';
  import Sharing from '../../components/Sharing.html';

  export default { 
    store: () => store,
     components: { Sharing
	},
	oncreate() {
		const state = store.get();
		const id = state.id;
		let activities = state.activities;

		
		if (!activities) {
			const urly = './activities.json';
			fetch(urly)
			.then(res => res.json())
			.then(activities => {
				let activity = {
				"titles": ["AAC Lessons, Articles, and Ideas from the perspective a parent with an adorable nonverbal child."],
				"subs": ["aac articles and strategies"],
				"file": {
					"value": "activities.html",
					"done": false
				},
				"tags": [],
				"dateRaw": "2019-02-21T19:04:22.815Z",
				"date": "Feb 21 2019",
				"settings": {
					"name": "ok",
					"img": "../img/talker_symbols/go.png",
					"desc": "Lessons and ideas for using your AAC device with nonverbal and autistic children.",
					"color": "navy", 
					"graphics": []
					}
				}
			
			  store.set({activity:activity, activities:activities});
			})
		}
		
	},
    methods: {
      goto(path) {
        roadtrip.goto(path);
      }
    }
  }
</script>